import { useState, useCallback, createContext, useContext } from 'react'

type ToastType = 'success' | 'error' | 'info'

interface ToastMessage {
  id: number
  text: string
  type: ToastType
}

interface ToastContext {
  toast: (text: string, type?: ToastType) => void
}

const ToastCtx = createContext<ToastContext>({ toast: () => {} })

let nextId = 0

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [messages, setMessages] = useState<ToastMessage[]>([])

  const toast = useCallback((text: string, type: ToastType = 'info') => {
    const id = nextId++
    setMessages((prev) => [...prev, { id, text, type }])
    setTimeout(() => {
      setMessages((prev) => prev.filter((m) => m.id !== id))
    }, 3000)
  }, [])

  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 items-center">
        {messages.map((m) => (
          <div
            key={m.id}
            className={`px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-all ${
              m.type === 'success' ? 'bg-success/90 text-white' :
              m.type === 'error' ? 'bg-error/90 text-white' :
              'bg-gray-800 text-white shadow-lg'
            }`}
          >
            {m.text}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  )
}

export function useToast() {
  return useContext(ToastCtx)
}
